var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5847 19.047C43.1647 20.6271 43.1647 23.1889 41.5847 24.7689C40.0046 26.349 37.4428 26.349 35.8628 24.7689C34.2827 23.1889 34.2827 20.6271 35.8628 19.047C37.4428 17.467 40.0046 17.467 41.5847 19.047Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4048 11.8247C30.8378 14.2577 30.8378 18.2023 28.4048 20.6353C25.9718 23.0682 22.0272 23.0682 19.5943 20.6353C17.1613 18.2023 17.1613 14.2577 19.5943 11.8247C22.0272 9.39176 25.9718 9.39176 28.4048 11.8247",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1374 19.047C13.7175 20.6271 13.7175 23.1889 12.1374 24.7689C10.5574 26.349 7.99558 26.349 6.41552 24.7689C4.83545 23.1889 4.83545 20.6271 6.41552 19.047C7.99558 17.467 10.5574 17.467 12.1374 19.047Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0004 38V35.808C46.0004 33.046 43.7624 30.808 41.0004 30.808H39.3984",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 38V35.808C2 33.046 4.238 30.808 7 30.808H8.602",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6783 38V34.798C34.6783 30.932 31.5443 27.798 27.6783 27.798H20.3203C16.4543 27.798 13.3203 30.932 13.3203 34.798V38",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUsers);
export default __webpack_public_path__ + "static/media/manageUsers.579b3c5b63e12b1631be94d0453715ae.svg";
export { ForwardRef as ReactComponent };